<template>
  <div>
    <div class="box">
      <BInputText
        label-text="机构名称"
        v-model="searchParam.name"
        placeholder="请输入机构名称"
      />
      <BInputText
        label-text="地址"
        v-model="searchParam.address"
        placeholder="请输入地址"
      />
      <BBtnSecondary
        :img-src="require('@/assets/filter.png')"
        :clicked="doSearch"
        hidden-key="true"
        btn-txt="筛选"
        style="margin-left: 30px;"
      />
    </div>
    <div class="search-result">
      <div class="search-functions-headers">
        <div class="search-functions">
          <BBtnPrimary
            :img-src="require('@/assets/new.png')"
            :clicked="orgAdd"
            btn-txt="添加机构"
          />
        </div>
      </div>
      <Table
        :headers="headers"
        class="timeDiscount"
        :tableData="orgList"
        :length="totalPages"
        :total-visible="7"
        :page-num="page"
        v-model="page"
        @input="doSearch(false)"
      >
        <template v-slot:actions="item">
          <div  v-if="item.data.id === 1"  style="display:flex;flex-direction:row;justify-content: center;">
            --
          </div>
          <div v-else style="display:flex;flex-direction:row;justify-content: center;">
            <div class="btn-detail" @click="handleDetail(item.data)">
              详情
            </div>
            <div  class="btn-delete" @click="handleDelete(item.data)">
              删除
            </div>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
import {
  searchList,
  orgDelete,
} from "@/api/organizationSystem";
import BInputText from "../../components2/BInputText";
import BBtnSecondary from "../../components2/BBtnSecondary";
import Table from "../../components2/Table";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Vue from "vue";
import PopupContents from "../../views2/sample/PopupContents";
import Hub from "../../events/Hub";
export default {
  name: "OrganizationManagement",
  components: {
    Table,
    BInputText,
    BBtnSecondary,
    BBtnPrimary,
  },
  data() {
    return {
      totalPages: 0,
      page: 1,
      limit: 10,
      totalCount: 0,
      headers: [
        { text: "ID", value: "indexNum", sortable: false, align: "center" },
        { text: "机构全称", value: "name", sortable: false },
        { text: "简称", value: "shortName", sortable: false },
        { text: "地址", value: "address", sortable: false  },
        { text: "法人", value: "supervisorName", sortable: false  },
        { text: "联系人", value: "contactName", sortable: false },
        { text: "创建时间", value: "createTime", sortable: false },
        { text: "操作", value: "actions", sortable: false, align: "center" },
      ],
      searchParam: {},
      // 机构List
      orgList: [],
      // 机构id
      oegId: null,
      data:{},
      deleteId:'',
      navi: [
        {name: "organization-management"},
      ],
    };
  },
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 判断是否是从菜单跳至此页面
      const isClear = vm.comUtils.checkUrl(from.name);
      // 如果是从菜单跳过来的 就 清除查询条件
      if (isClear === "true") {
        vm.$store.commit("REMOVE_ORG_MANAGER_PARAMS");
        vm.$store.commit("SET_ORG_MANAGER_PAGE", 1);
      }
      // 查询条件赋值
      if (vm.$store.state.orgManagement_name !== undefined) {
        vm.searchParam.name = vm.$store.state.orgManagement_name;
      }
      if (vm.$store.state.orgManagement_address !== undefined) {
        vm.searchParam.address = vm.$store.state.orgManagement_address;
      }
      vm.doSearch(true);
    });
  },
  beforeMount() {
    this.$store.commit('SET_NAVI_DATA', this.navi);
  },
  methods: {
    // 课程添加
    orgAdd() {
      this.$router.push({
        name: "organization-management-add",
      });
    },
    // 详情
    handleDetail(val) {
      this.$router.push({
        name: "organization-management-add",
        params: {
          orgId: val.id,
        },
      });
    },
    // 删除
    handleDelete(val) {
        this.data.bodyText = "确认删除该机构？";
        this.deleteId = val.id;
        Hub.$emit("open-modal");
        Hub.$emit("set-modal-data", this.data.bodyText, "删除", PopupContents);
    },
    // 课程删除
    async orgDelete(id) {
      var param = {
        id: id,
      };
      const data = await orgDelete(param);
      if (data.msg === "删除成功") {
        Vue.prototype.$vsnackbar.show(data.msg);
        this.doSearch(true)
      } else {
        Vue.prototype.$vsnackbar.show(data.msg);
      }
    },
    // 查询
    doSearch(flg) {
      this.loading = true;
      if (flg) {
        this.totalPages = 0;
        this.page = 1;
        this.limit = 10;
        this.totalCount = 0;
        if (this.$route.query.backFlg !== "1") {
          this.$store.commit("SET_ORG_MANAGER_PAGE", this.page);
        } else {
          this.$route.query.backFlg = "";
        }
      } else {
        // 查询条件赋值
        if (this.$store.state.orgManagement_name !== undefined) {
        this.searchParam.name = this.$store.state.orgManagement_name;
        }
        if (this.$store.state.orgManagement_address !== undefined) {
            this.searchParam.address = this.$store.state.orgManagement_address;
        }
        this.$store.commit("SET_ORG_MANAGER_PAGE", this.page);
      }
      this.searchList(this.searchParam);
    },
    async searchList(searchParam) {
      // 把查询条件存入缓存
      this.$store.commit("SET_ORG_MANAGE_PARAMS", this.searchParam);
      var pageCnt = this.page;
      if (
        this.$store.state.orgManagement_page !== undefined &&
        this.$store.state.orgManagement_page !== ""
      ) {
        pageCnt = this.$store.state.orgManagement_page;
      }

      var param = {
        page: pageCnt,
        limit: this.limit,
        name: this.comUtils.trim(searchParam.name),
        address: this.comUtils.trim(searchParam.address),
      };
      const data = await searchList(param);
      if (data.data.searchList !== null || data.data.searchList === "") {
        this.orgList = data.data.searchList;
      }
      this.totalCount = data.data.totalPage;
      this.totalPages = Math.ceil(this.totalCount / this.limit);
      this.page = this.$store.state.orgManagement_page;
      if (this.page > this.totalPages && this.totalPages > 0) {
        this.$store.commit("SET_ORG_MANAGER_PAGE", 1);
        this.doSearch(true);
      }
      this.loading = false;
    },
     set(value) {
      console.info(value);
      if (value === 1) {
            // 成功 页面刷新
          this.orgDelete(this.deleteId)
       }
    },
  },
   destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
  mounted() {
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
};
</script>

<style scoped>
.main2 {
  position: relative;
  /*margin: 5px 30px 5px 30px;*/
  padding-top: 28px;
  display: flex;
  flex-wrap: wrap;
}

.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: 0;
}

.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
.timeDiscount{
  white-space: pre-line;
}
</style>
